import { render, staticRenderFns } from "./checkTomore.vue?vue&type=template&id=68d2da64&scoped=true&"
import script from "./checkTomore.vue?vue&type=script&lang=js&"
export * from "./checkTomore.vue?vue&type=script&lang=js&"
import style0 from "./checkTomore.vue?vue&type=style&index=0&id=68d2da64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2da64",
  null
  
)

export default component.exports